<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <span class="h5">
          PERFIS DE ACESSO -
          <b-badge variant="warning">{{operacao}}</b-badge>
        </span>
      </b-card-header>
      <b-card-body>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <div>
          <b-row>
            <b-col sm="5">
              <b-form-group>
                <label for="codPerfilAcesso">Código</label>
                <b-form-input
                  type="text"
                  placeholder="Digite o código do perfil de acesso"
                  v-model="perfilAcessoDto.codPerfilAcesso"
                  @input="$v.perfilAcessoDto.codPerfilAcesso.$touch()"
                  :state="$v.perfilAcessoDto.codPerfilAcesso.$error ? false : null"
                  :disabled="desabilitarFormulario"
                ></b-form-input>
                <b-form-invalid-feedback>O código do perfil de acesso é obrigatório</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="7">
              <b-form-group>
                <label for="descricaoPerfilAcesso">Descrição</label>
                <b-form-input
                  type="text"
                  id="descricaoPerfilAcesso"
                  placeholder="Digite a descrição da perfil de acesso"
                  v-model="perfilAcessoDto.descricaoPerfilAcesso"
                  @input="$v.perfilAcessoDto.descricaoPerfilAcesso.$touch()"
                  :state="$v.perfilAcessoDto.descricaoPerfilAcesso.$error ? false : null"
                  :disabled="desabilitarFormulario"
                ></b-form-input>
                <b-form-invalid-feedback>A descrição do perfil de acesso é obrigatória</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
      <b-card-footer>
        <b-button
          variant="primary"
          v-if="mostraBtnAtualizar"
          @click.stop="transfereParaAtualizacao()"
          class="mr-2"
        >
          <i class="fa fa-edit"></i> Atualizar
        </b-button>
        <b-button
          variant="primary"
          @click.stop="salvarForm()"
          :disabled="!habilitarSalvar"
          v-if="mostraBtnSalvarCancelar"
          class="mr-2"
        >
          <i class="fa fa-save"></i> Salvar
        </b-button>
        <b-button variant="danger" @click.stop="cancelar()" class="mr-2">
          <span v-if="mostraBtnSalvarCancelar">
            <i class="fa fa-remove"></i> Cancelar
          </span>
          <span v-if="!mostraBtnSalvarCancelar">
            <i class="fa fa-history"></i> Voltar
          </span>
        </b-button>
      </b-card-footer>
    </b-card>
    <app-perfil-regras-acesso v-if="operacao === 'DETALHAR'"></app-perfil-regras-acesso>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import PerfisAcessoServicos from "./PerfisAcessoServicos.js";
import PerfilRegrasAcesso from "./PerfilRegrasAcesso";

export default {
  data() {
    return {
      operacao: "",
      erros: [],
      perfilAcessoDto: {
        perfilAcessoId: "",
        codPerfilAcesso: "",
        descricaoPerfilAcesso: ""
      }
    };
  },
  methods: {
    salvarForm() {
      let perfilAcesso = {
        CodPerfilAcesso: this.perfilAcessoDto.codPerfilAcesso.toUpperCase(),
        DescricaoPerfilAcesso: this.perfilAcessoDto.descricaoPerfilAcesso.toUpperCase()
      };
      if (this.operacao === "INSERIR") {
        this.inserirPerfilAcesso(perfilAcesso);
      } else {
        perfilAcesso.PerfilAcessoId = this.perfilAcessoDto.perfilAcessoId;
        this.atualizarPerfilAcesso(perfilAcesso);
      }
    },
    
    obterUsuario() {
            this.$store.dispatch('addRequest')
            UsuariosServicos.obterPorId(this.$route.params.usuarioId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.usuario = response.data
                            this.usuario.telefone = this.$mask(
                                this.usuario.telefone,
                                ['(##) ####-####', '(##) #####-####']
                            )
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

    cancelar() {
      this.erros = [];
      if (this.operacao === "ATUALIZAR") {
        this.$router.push({
          name: "PerfisAcesso_Detalhar",
          params: { perfilAcessoId: this.$route.params.perfilAcessoId }
        });
      } else {
        this.$router.push({ name: "PerfisAcesso" });
      }
    },

    inserirPerfilAcesso(perfilAcesso) {
      this.$store.dispatch("addRequest");
      PerfisAcessoServicos.inserirPerfilAcesso(perfilAcesso).then(response => {
        if (response) {
          if (response.success) {
            this.registroSalvoComSucesso(response.data);
          } else {
            this.erros = response.errors;
          }
        }
        this.$store.dispatch("removeRequest");
      });
    },

    obterPerfilAcesso() {
      this.$store.dispatch("addRequest");
      PerfisAcessoServicos.obterPorId(this.$route.params.perfilAcessoId).then(
        response => {
          if (response) {
            if (response.success) {
              this.preencheFormulario(response.data);
            } else {
              this.erros = response.errors;
            }
          }
          this.$store.dispatch("removeRequest");
        }
      );
    },

    atualizarPerfilAcesso(perfilAcesso) {
      this.$store.dispatch("addRequest");
      PerfisAcessoServicos.atualizarPerfilAcesso(perfilAcesso).then(
        response => {
          if (response) {
            if (response.success) {
              this.registroSalvoComSucesso(perfilAcesso.PerfilAcessoId);
            } else {
              this.erros = response.errors;
            }
          }
          this.$store.dispatch("removeRequest");
        }
      );
    },

    registroSalvoComSucesso(data) {
      this.erros = [];
      this.$toast.success(
        "Registro salvo com sucesso!",
        "OK",
        this.$toastConfig.success
      );
      this.$store.dispatch("setRecarregar", true);
      this.$router.push({
        name: "PerfisAcesso_Detalhar",
        params: { perfilAcessoId: data }
      });
    },

    preencheFormulario(data) {
      this.perfilAcessoDto.perfilAcessoId = data.perfilAcessoId;
      this.perfilAcessoDto.codPerfilAcesso = data.codPerfilAcesso;
      this.perfilAcessoDto.descricaoPerfilAcesso = data.descricaoPerfilAcesso;
    },

    transfereParaAtualizacao() {
      this.$router.push({
        name: "PerfisAcesso_Atualizar",
        params: { perfilAcessoId: this.$route.params.perfilAcessoId }
      });
    },

    processarRota(rota) {
      if (rota.name === "PerfisAcesso_Inserir") {
        this.operacao = "INSERIR";
      } else if (rota.name === "PerfisAcesso_Detalhar") {
        this.operacao = "DETALHAR";
        this.obterPerfilAcesso();
      } else if (rota.name === "PerfisAcesso_Atualizar") {
        this.operacao = "ATUALIZAR";
        this.obterPerfilAcesso();
      }
    }
  },

  computed: {
    habilitarSalvar() {
      return !this.$v.$invalid;
    },

    desabilitarFormulario() {
      return this.operacao === "DETALHAR";
    },

    mostraBtnSalvarCancelar() {
      return (
        (this.operacao === "INSERIR" || this.operacao === "ATUALIZAR") &&
        (this.$temAcessoView("CTRLACS-PA-01") ||
          this.$temAcessoView("CTRLACS-PA-03"))
      );
    },

    mostraBtnAtualizar() {
      return (
        !this.mostraBtnSalvarCancelar &&
        (this.$temAcessoView("CTRLACS-PA-01") ||
          this.$temAcessoView("CTRLACS-PA-03"))
      );
    }
  },

  created() {
    this.processarRota(this.$route);
  },

  watch: {
    $route(to, from) {
      this.processarRota(to);
    }
  },

  validations: {
    perfilAcessoDto: {
      codPerfilAcesso: {
        required
      },
      descricaoPerfilAcesso: {
        required
      }
    }
  },

  components: {
    AppPerfilRegrasAcesso: PerfilRegrasAcesso
  }
};
</script>
